<div class="bg-white p-6 rounded-xl">
  <!-- Market insights -->
  <div class="relative blue-card h-36 p-3 mb-8">
    <app-assistant-prompt
      tag="ASK_ASSISTANT_BASIC_WORDS_IN_LOCAL_LANGUAGE"
      title="Communication summary"
      [company]="company"
      [showButton]="true"
      [buttonType]="2"
      [class]="'text-sm line-clamp-3'"
      [reportId]="report?.id"
    >
    </app-assistant-prompt>
  </div>

  <!-- Mobile select -->
  <div class="grid grid-cols-1 sm:hidden">
    <select
      [(ngModel)]="selectedTab"
      (ngModelChange)="selectTab($event)"
      aria-label="Select a tab"
      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-200 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
    >
      <option *ngFor="let tab of tabs" [ngValue]="tab">{{ tab.name }}</option>
    </select>
    <svg
      class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      data-slot="icon"
    >
      <path
        fill-rule="evenodd"
        d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
        clip-rule="evenodd"
      />
    </svg>
  </div>

  <!-- Desktop tabs -->
  <div class="hidden sm:block">
    <div class="border-b border-gray-200">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <a
          *ngFor="let tab of tabs"
          href="#"
          (click)="selectTab(tab); $event.preventDefault()"
          class="flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
          [class.border-orange-500]="tab.current"
          [class.text-orange-500]="tab.current"
          [class.border-transparent]="!tab.current"
          [class.text-gray-500]="!tab.current"
          [class.hover:border-gray-200]="!tab.current"
          [class.hover:text-gray-700]="!tab.current"
          [attr.aria-current]="tab.current ? 'page' : undefined"
        >
          {{ tab.name }}
        </a>
      </nav>
    </div>
  </div>

  <!-- Unified list view -->
  <!-- Container with consistent height -->
  <div>
    <!-- Content Section -->
    <div
      *ngIf="
        currentList.length > 0 &&
        (this.tabs[0].current ? isLoadedMail : isLoadedDeals)
      "
      class="min-h-[250px] sm:min-h-[350px] h-full sm:overflow-hidden overflow-x-auto"
    >
      <div class="w-full sm:w-auto min-w-max sm:min-w-full">
        <div class="flex flex-col">
          <a
            *ngFor="let item of currentList"
            class="flex space-x-2 ß items-center border-b border-gray-100 hover:bg-gray-50 py-3 px-3 min-w-max sm:min-w-full"
            [class.bg-white]="selectedTab.name === 'Messages'"
          >
            <!-- Full width container to ensure proper spacing -->
            <div class="w-full flex items-center">
              <!-- Left section - Subtitle -->
              <div class="pr-4 text-sm text-left shrink-0">
                <h3
                  [class.font-semibold]="!item.isRead"
                  [class.font-medium]="item.isRead"
                >
                  {{ item.subtitle }}
                </h3>
              </div>

              <!-- Middle section - Title and Preview (Expands) -->
              <div class="flex flex-col space-y-1 flex-grow sm:px-4 min-w-0">
                <span class="text-sm font-semibold line-clamp-1">
                  {{ item.title }}
                </span>

                <span
                  class="text-sm text-gray-500 sm:line-clamp-2 line-clamp-3"
                >
                  {{ item.preview }}
                </span>
              </div>

              <!-- Right section - Date (Always Sticks to the Right) -->
              <div class="pl-4 text-right shrink-0">
                <span class="text-sm text-gray-500">
                  {{ item.date }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Loader Section -->
    <div
      class="flex items-center justify-center min-h-[250px] sm:min-h-[350px] m-auto py-4"
      [class.hidden]="isLoadedMail"
    >
      <div class="text-center">
        <svg
          class="mx-auto animate-spin h-6 w-6 text-primary mb-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <h1
          class="text-sm font-semibold leading-none tracking-tight text-primary"
        >
          Loading Gmails Data
        </h1>
      </div>
    </div>

    <div
      class="flex items-center justify-center min-h-[250px] sm:min-h-[350px] m-auto py-4"
      [class.hidden]="isLoadedDeals"
    >
      <div class="text-center">
        <svg
          class="mx-auto animate-spin h-6 w-6 text-primary mb-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <h1
          class="text-sm font-semibold leading-none tracking-tight text-primary"
        >
          Loading Deals Data
        </h1>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      this.deals.length === 0 &&
      tabs[1].current &&
      this.report.email !== '' &&
      this.report.email !== null &&
      isLoadedDeals
    "
  >
    <div
      *ngIf="this.isConnectedToHubSpot == true && this.deals.length == 0"
      class="py-4 flex flex-row justify-start items-center"
    >
      <span class="font-normal"
        >No Deals found with
        <span class="font-semibold">{{ this.report.email }}</span></span
      >
    </div>

    <div
      *ngIf="this.isConnectedToHubSpot == false"
      class="py-4 flex flex-row justify-start items-center"
    >
      <span class="font-normal"
        >Please
        <a routerLink="/settings/account"
          ><span class="font-bold underline">connect</span></a
        >
        your hubspot account to view CRM data
      </span>
    </div>
  </div>

  <div
    *ngIf="
      this.messages.length === 0 &&
      tabs[0].current &&
      this.report.email !== '' &&
      this.report.email !== null &&
      isLoadedMail
    "
  >
    <div
      *ngIf="this.isConnectedToGmail !== false && this.messages.length == 0"
      class="py-4 flex flex-row justify-start items-center"
    >
      <span class="font-normal"
        >No emails found with
        <span class="font-semibold">{{ this.report.email }}</span></span
      >
    </div>

    <div
      *ngIf="this.isConnectedToGmail == false"
      class="py-4 flex flex-row justify-start items-center"
    >
      <span class="font-normal"
        >Please
        <a routerLink="/settings/account"
          ><span class="font-bold underline">connect</span></a
        >
        your Google account to view Mail data
      </span>
    </div>
  </div>

  <div *ngIf="this.report.email == null || this.report.email == ''">
    <div class="py-4 flex flex-row justify-start items-center">
      <span class="font-normal"
        >This report does not have an email associated
        <span class="font-semibold">{{ this.report.email }}</span></span
      >
    </div>
  </div>

  <!-- Pagination -->
  <div
    *ngIf="currentList.length > 0"
    class="flex items-center justify-between bg-white dark:bg-indigo-custom rounded-b-lg py-3"
  >
    <app-emails-pagination
      (pageChanged)="onPageChanged($event)"
      [pagination]="pagination"
      [hasNextPage]="hasNextPage"
      class="w-full"
    ></app-emails-pagination>
  </div>
</div>
